import { translate } from 'rcffus-sps-translations';

import { getDefaultStateForMoreFilters } from '../../components/ElectronicJournal/Npos/nposUtils';
import { translateByLocale, translateBodyByLocale } from '../../utils/ej-utils';
import { locales } from '../../utils/locales';
import { ejBodyKeys, ejKeys } from '../../utils/static/bodegaKeys/ej-keys';
import {
 LOAD_ADMIN_PERMISSIONS, LOAD_BODY_TRANSLATIONS, LOAD_TRANSLATIONS, SET_NPOS_VALUES, SET_NPOS_ERRORS, SET_NPOS_FILTERS, TOGGLE_UI,
 SET_PRINTER_JOB_INFO
} from '../actions';

const MORE_FILTERS = getDefaultStateForMoreFilters();

const initialState = {
  isAdmin: false,
  localizedBody: translateBodyByLocale(translate, ejBodyKeys, 'en-US'),
  redacted: '████',
  ...translateByLocale(translate, ejKeys, locales('en-US'), 'en-US'),
  defaultPrinterInfo: null,
  nposErrors: {},
  nposFilters: {
      cardNo: { creditDebitCardNo: '', giftCardNo: '' },
      currentStore: {},
      selectedDates: null,
      tenderType: null,
      upc: null,
      ...MORE_FILTERS
  },
  nposValues: {
    currentPage: 1,
    doInitialLoad: true,
    fetchingCompleted: false,
    isHomePage: true,
    isPrinterDialogOpen: false,
    isStoreSwitched: false,
    openFilter: null,
    printJobInfo: null,
    sessionContext: null,
    showNewUi: false,
    switchUiAvailable: false,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_ADMIN_PERMISSIONS:
      return {
        ...state,
        isAdmin: action.isAdmin,
      };
    case LOAD_TRANSLATIONS:
      return {
        ...state,
        ...translateByLocale(translate, ejKeys, action.localeInfo, action.localeInfo.localeName),
      };
    case LOAD_BODY_TRANSLATIONS:
      return {
        ...state,
        localizedBody: translateBodyByLocale(translate, ejBodyKeys, action.translatedLocaleName),
      };
    case TOGGLE_UI:
        return {
          ...state,
          nposValues: { ...state.nposValues, showNewUi: action.showNewUi },
        };

    case SET_NPOS_FILTERS:
      return {
        ...state,
        nposFilters: { ...state.nposFilters, ...action.filter },
      };
      case SET_NPOS_ERRORS:
        return {
          ...state,
          nposErrors: action.flush ? {} : { ...state.nposErrors, ...action.error },
        };
      case SET_NPOS_VALUES:
        return {
          ...state,
          nposValues: { ...state.nposValues, ...action.nposValues },
        };
      case SET_PRINTER_JOB_INFO:
        return {
          ...state,
          nposValues: { ...state.nposValues, printJobInfo: { ...state.nposValues.printJobInfo, ...action.printJobInfo } },
        };
    default:
      return state;
  }
};

export default reducer;
